export default {
  Language: '中文',
  system: {
    homePage: {
      login: '登录',
      register: '注册',

    },
    headerMenu: {
      HomePage: "首页",
      ScientificData: "科学数据",
      PDSDataSet: "PDS卷集",
      WebGis: "WebGis",
      Moon: "月球",
      Mars: "火星",
      Planet: "行星",
      SampleMoon: "月球样品",
      SampleAsteroid: '小行星样品',
      LunarSample: "行星地名库",
      PopularScience: "科普教育",
      ResourceTools: "资源工具",
      AboutUs: "关于我们",
      PlanetaryDatabaseName: "行星地库名",
      extraterrestrial: "地外样品",
    },
    infoData: {
      lastNew: "最新动态",
      more: "更多",
      Roam: "月球",
      Lunar: "火星",
      MoonandPlanets: "全景漫游",
      PopularScience: "科普教育",

      RecentNews: "最新数据",
      DataRelease: "数据发布",
      TasksIntroduction: "任务介绍",
      OngoingNews: "动态新闻",
      LatestProduct: "最新成果",
      NoticeandAnnouncement: "通知公告",
      Other: "其他",
      ReleaseTime: "发布时间",
      PageViews: "浏览次数"
    },
    footData: {
      Name: "中国科学院国家天文台月球与深空探测科学应用中心",
      ContactUs: "联系我们",
      RecordNumber: "备案序号",
      WenbaoNetworkSecurityFilingNumber: "文保网安备案号"
    },

    PopularScience: {
      Moon: "月球",
      Mars: "火星",
      ViewCount: "浏览量",
      AllCategories: "全部分类",
      DataIndex: "数据索引",
      Producer: "制作方",
      Description: "描述",
      Time: "时间"
    },
    ResourceTools: {
      ResourceTools: "资源工具",
      ScienceProducts: "科普产品",
      ModelProducts: "模型产品",
      Books: "图书专著",
      NationalStandard: "国家标准",
      ReleaseTime: "发布时间",
      intro: '简介'
    }
  },
  regist: {
    UserType: "用户类型",
    UserName: "用户账号",
    Email: "邮 箱",
    RealName: "真实姓名",
    Password: "设置密码",
    ConfirmPassword: "确认密码",
    VerificationCode: "验证码",
    Company: "单位",
    Telephone: "手机号码",
    Fax: "",
    DetailedAddress: "",
    Postcode: ""
  },
  ScientificData: {
    DataCatalog: "数据目录",
    ScientificDataTree: "科学数据目录树",
    MissionIntroduction: "任务介绍",
    ReturnHomePage: "返回首页",
    DataDeclaration: "数据说明",
    ReferenceAndAcknowledgement: "引用致谢",
    CopyrightNotice: "版权声明",
    CurrentPosition: "当前位置",
    HomePage: "首页",
    ScientificData: "科学数据",
    Mars: "行星",
    Moon: "月球",
    Tianwen: "天问一号",
    TaskModel: "任务型号",
    DataType: "数据类型",
    PublicData: "公共数据",
    ProtectedData: "保护数据",
    CarryingPlatform: "搭载平台",
    DataAcquisitionTime: "数据获取时间",
    FirstReleaseTime: "首次发布时间",
    LatestReleaseTime: "最新发布时间",
    DataStatus: "数据状态",
    PublicAccess: "公开获取",
    AuthorizedAccess: "授权获取",
    Others: "其他",
    DataServiceContactInformation: "数据服务联系方式",
    TotalReleaseBatches: "发布批次总计",
    DataVolume: "数据量",
    DataFormat: "数据格式",
    DataVersion: "数据版本",
    DataProducer: "数据生产者",
    DataAceess: {
      Payload: "有效载荷",
      DataLevel: "数据级别",
      AdvancedSearch: "高级检索",
      Longitude: "经度",
      Latitude: "纬度",
      DisplayonPlanetMap: "在行星图中显示",
      Reset: "重置",
      DataName: "数据名称",
      StartTime: "开始时间",
      EndTime: "结束时间",
      OrbitNumber: "轨道圈数",
      Search: "检索",
      ClearSearch: "收回检索",
      DataList: "数据列表",
      ExpandMore: "展开更多",
      ReceivingStation: "接收站",
      DetectionMission: "探测任务",
      Size: "大小",
      DataVersion: "数据版本",
      BatchDownload: "批量下载",
      BatchFavorite: "批量收藏",
      DownloadNow: "立即下载",
      CancelFavorites: "取消收藏",
      AddtoFavorites: "加入收藏夹",
      DataAcquisition: "数据获取",
      NoDataAvailable: "暂无数据",
      DataStatus: "数据状态"
    }
  },
  DetailMoon: {
    startDate: '数据开始日期',
    endDate: '数据终止日期',
    genDate: '数据产生日期',
    releaseTime: '最新发布时间',
    producer: '数据生产者',
    applyDownload: '申请下载',
    pendingReview: '待审核',
    doi: 'DOI'
  },
  Login: {
    UserName: "用户名",
    PassWord: "密码",
    CheckCode: "验证码",
    ForgottenPassword: "忘记密码",
    Login: "登录",
    Cancel: "取消",
    PleaseLogin: "请登录",
    NewUserRegistration: "新用户注册",
    ResetPassword: "重置密码",
    Submit: "提交",
    PleaseEnterYourPassword: "请输入密码",
    PleaseEnterUserAccount: "请输入用户账号"
  },
  Register: {
    title: '注册',
    Submit: "提交",
    userType: '用户类型',
    userTypeSci: '科学数据用户',
    userTypeSample: '样品用户',
    accountLabel: '用户账号',
    accountPlaceholder: '您的账户名和登录名',
    nameLabel: '真实姓名',
    namePlaceholder: '您的真实姓名',
    phoneLabel: '手机号码',
    phonePlaceholder: '请输入手机号码',
    emailLabel: '邮箱',
    emailPlaceholder: '请输入邮箱',
    companyLabel: '单位',
    companyPlaceholder: '请输入单位全称',
    idCardLabel: '身份证号',
    pwdLabel: '设置密码',
    pwdConfirmLabel: '确认密码',
    pwdConfirmTip: '密码6-16位，区分大小写',
    codeLabel: '验证码',
    codePlaceholder: '输入验证码',
    goLogin: '使用已有账号登录'
  },
  FileData: {
    ScientificData: "科学数据",
    Mars: "行星",
    FileName: "文件名称",
    FileSize: "文件大小",
    Action: "操作",
    ViewDetail: "查看详情",
    Download: "下载"
  },
  PDS: {
    CurrentPosition: "当前位置：",
    HomePage: "首页",
    PDSDataSet: "PDS卷集",
    Moon: "月球",
    Payload: "有效载荷",
    DataLevel: "数据级别",
    CollectionStartTime: "采集起始时间：",
    CollectionEndTime: "采集结束时间：",
    Search: "检索",
    VolumeDataStartTime: "卷内数据开始时间：",
    VolumeDataEndTime: "卷内数据结束时间：",
    DetectionTask: "探测任务：",
    DataSize: "数据大小：",
    FileTotal: "文件总数：",
    DownloadNow: "立即下载"
  },
  MoonSample: {
    PleaseSelectData: "请选择数据！",
    OrderCreatedSuccess: "生成订单成功！",
    Total: "共",
    Records: "条",
    WebsiteHomePage: "网站首页",
    MoonSampleHome: "月球样品首页",
    MoonSampleSearch: "月球样品查询",
    SampleInfoDescription: "样品信息说明",
    BorrowingAndReturn: "借用与返回",
    AboutUs: "关于我们",
    MoonSampleInformationDatabase: "月球样本信息数据库",
    LunarSampleInformationDatabase: "LUNAR SAMPLE INFORMATION DATABASE",
    MoonSampleInformationAnnouncement: "月球样品信息公告",
    More: "更多",
    LatestNews: "最新动态",
    SampleNumberRules: "样品编号规则",
    AvailableSampleSearch: "可借用样品查询",
    MySamples: "我的样品",
    ReapplyRejected: "样品申请驳回再提交",
    SampleType: "样品类型",
    SampleFeature: "样品特征",
    CanApply: "可申请",
    Borrowing: "借用中",
    BorrowingReview: "借用审核中",
    ReturnMonitoring: "返还监测中",
    Operation: "操作",
    Details: "详情",
    NoData: "暂无数据",
    TotalRecords: "总共 {count} 条记录",
    DetectTaskInfo: "探测任务信息",
    DetectTask: "探测任务",
    Location: "地点",
    Longitude: "经度",
    Latitude: "纬度",
    SampleBasicInfo: "样品基本信息",
    SampleCode: "样品编号",
    SampleBorrowingInfo: "样品借用信息",
    UseUnit: "使用单位",
    ResponsiblePerson: "使用责任人",
    UseStatus: "使用状态",
    IssuedWeight: "发放质量(mg)",
    ReturnWeight: "返还质量(mg)",
    Status: "状态",
    DistributionReview: "分发审核中",
    PendingDistribution: "待分发",
    BorrowRejected: "借用审核驳回",
    ReturnDetection: "返还检测中",
    DetectionPassed: "检测通过",
    DetectionFailed: "检测不通过",
    PhotoSampleInfo: "图片样本信息",
    ExhibitionEducation: "展览教育科普",
    Gift: "赠送",
    Other: "其他",
    ReturnDetectionResult: "返还检测结果",
    BatchBorrow: "批量借用",
    SearchResults: "查询结果：共{total}条",
    Submit: "提 交",
    MoonSampleBorrowApplication: "月球样品借用申请信息",
    PleaseLogin: "请登录用户！",
    PageHeaderBack: "返回",
    PageHeaderContent: "详情页面",
    Unavailable: "不可申请",
    PendingSampling: "待取样",
    PleaseSelect: "请选择",
    Quantity: "数量(个)",
    Weight: "重量(mg)",
    ParticleSize: "样品粒度(毫米)",
    SamplePhoto: "样本照片",
    SampleClassificationInfo: "样品分类信息",
    SampleDescriptionInfo: "样品描述信息",
    SampleClassification: "样品分类信息",
    Level1Category: "一级分类",
    Level2Category: "二级分类",
    Level3Category: "三级分类",
    Level4Category: "四级分类",
    PrimaryCategory: "一级分类",
    SecondaryCategory: "二级分类",
    TertiaryCategory: "三级分类",
    QuaternaryCategory: "四级分类",
    Color: "颜色",
    Structure: "结构",
    MineralComposition: "矿物组成",
    SampleDescription: "样品说明",
    SampleQuantity: "样品数量",
    UseMethod: "使用方式",
    UsageMethod: "使用方式",
    OriginalUse: "原样使用",
    AsIsUsage: "原样使用",
    ConsumptiveUse: "消耗性使用",
    ConsumptiveUsage: "消耗性使用",
    DestructiveUse: "破坏性使用",
    DestructiveUsage: "破坏性使用",
    Returned: "已返还",
    NoDescription: "没有描述信息",
    SampleDescriptionText: "样品说明",
    UsingDepartment: "使用单位",
    ReturnTesting: "返还检测中",
    TestPassed: "检测通过",
    TestFailed: "检测不通过",
    ReturnTestResult: "返还检测结果",
    ImageSampleInfo: "图片样本信息",
    ContactInformation: "联系方式",
    Email: "邮箱",
    MySamplesDataDisplay: "我的样品数据展示",
    UseTime: "使用时间",
    PleaseSelectStartUseTime: "请选择开始使用时间",
    PleaseSelectActualReturnTime: "请选择实际返还时间",
    Confirm: "确定",
    BorrowWeight: "借用质量(mg)",
    ExpectedConsumption: "预期消耗量(mg)",
    UseResponsiblePerson: "使用责任人",
    StartUseTime: "开始使用时间",
    EndUseTime: "结束使用时间",
    ReviewRejected: "审核驳回",
    Completed: "已终结",
    Return: "返还",
    ApplyChange: "申请变更",
    ReturnApplication: "返还申请表",
    PleaseInputSampleCode: "请输入样品编码",
    PleaseInputBorrowWeight: "请输入借用质量",
    PleaseSelectExpectedReturnTime: "请选择预计返还时间",
    PleaseInputExpectedConsumption: "请输入预期消耗量",
    ActualConsumption: "实际消耗量(mg)",
    PleaseInputActualConsumption: "请输入实际消耗量",
    PleaseInputReturnWeight: "请输入样品返还质量",
    PleaseUploadReturnMaterials: "请在下方对应上传样品返还配套资料",
    SampleUsageReport: "样品使用报告",
    ClickUpload: "点击上传",
    SampleTestAnalysisData: "样品测试与分析数据",
    SampleUsageRecord: "样品使用过程记录",
    Remark: "备注",
    PleaseInputRemark: "请输入备注",
    OrderInformation: "订单信息",
    SampleId: "借用样品id",
    OrderNumber: "订单编号",
    LegalPerson: "使用单位法人",
    LegalPersonId: "法人身份证号",
    LegalPersonPhone: "法人联系电话",
    LegalPersonEmail: "法人电子邮箱",
    ResponsiblePersonId: "责任人身份证号",
    ResponsiblePersonPhone: "责任人联系电话",
    ResponsiblePersonEmail: "责任人电子邮箱",
    ExpectedReturnTime: "预计返还时间",
    ActualReturnTime: "实际返还时间",
    BorrowReviewer: "借用审核员",
    BorrowReviewTime: "借用审核时间",
    ReturnReviewer: "返还审核员",
    ReturnReviewTime: "返还审核时间",
    ChangeApplication: "变更申请",
    ExpectedChangeConsumption: "预计变更消耗量(mg)",
    ExpectedChangeReturnDate: "预计变更返还日期",
    PleaseSelectDate: "选择日期时间",
    ChangeApplicationForm: "变更申请表",
    Education: "教育",
    PopularScience: "科普",
    ResubmitApplication: "样品申请再提交",
    Resubmit: "重新提交",
    InternalBorrowing: "内部借用",
    ExternalBorrowing: "外部借用",
    ReturnReviewReason: "返还审核驳回原因",
    Cancel: "取消"
  }
};
